module.exports = __webpack_public_path__ + "img/points.e950d1c2.png";